import CustomButton from '@/common/CustomButton';
import {
  CalendarOutlined,
  LeftOutlined,
  PlusOutlined,
  RightOutlined
} from '@ant-design/icons';
import DetailCard from './DetailCard';
import CreateFollowUpModal from './CreateFollowUpModal';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Button, Empty, Switch, Typography } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getCategorizedFollowUps } from '../redux/slice';
import { getFormattedDateToSend } from 'utilities/helpers';

export default function FollowUpPage() {
  const [isNewFollowUpModalOpen, setIsNewFollowUpModalOpen] = useState(false);
  const [selectedDate, setselectedDate] = useState(moment);
  const [isTeam, setIsTeam] = useState(false);
  const [followUpData, setFollowUpData] = useState({
    data: {},
    statistics: {}
  });

  const dispatch = useDispatch();

  const goToPreviousDay = () => {
    const newDate = moment(selectedDate).subtract(1, 'day');
    setselectedDate(newDate.toDate());
  };

  const goToNextDay = () => {
    const newDate = moment(selectedDate).add(1, 'day');
    setselectedDate(newDate.toDate());
  };

  const handleLoadFollowUps = (date, isTeam) => {
    const payload = {
      followup_date: getFormattedDateToSend(date),
      type: isTeam ? 'all' : 'me'
    };
    dispatch(getCategorizedFollowUps(payload)).then((res) => {
      if (res?.payload?.success) {
        setFollowUpData({
          data: res?.payload?.data,
          statistics: res?.payload?.statistics
        });
      }
    });
  };

  useEffect(() => {
    handleLoadFollowUps(selectedDate, isTeam);
  }, [selectedDate, isTeam]);

  return (
    <div className="flex flex-col gap-6">
      {/* header */}
      <div className="flex items-center justify-between">
        <h5 className={'!text-xl md:!text-3xl !font-bold md:mt-0 mt-2'}>
          Follow-ups
        </h5>

        <CustomButton
          icon={<PlusOutlined />}
          className={'!text-sm rounded-md md:block hidden'}
          type="primary"
          onClick={() => setIsNewFollowUpModalOpen(true)}
        >
          New Follow-up
        </CustomButton>
        <CustomButton
          icon={<PlusOutlined />}
          className={'!text-sm rounded-md block md:hidden'}
          type="primary"
          size="small"
          onClick={() => setIsNewFollowUpModalOpen(true)}
        >
          New Follow-up
        </CustomButton>
      </div>
      {/* action buttons */}
      <div className="flex flex-col items-center gap-2 sm:flex-row md:gap-3">
        {/* date selector */}
        {/* <div ref={anchorRef} className="relative flex w-28">
          <Button
            className="!text-sm !font-semibold tracking-wide h-8 items-center flex"
            variant="outlined"
            onClick={() => setIsDatePickerOpen(true)}
          >
            {selectedDate ? selectedDate : moment().format('DD/MM/yyyy')}
          </Button>
          <DatePicker
            open={isDatePickerOpen}
            placement="bottomRight"
            getPopupContainer={() => anchorRef.current}
            onOpenChange={(status) => setIsDatePickerOpen(status)}
            onChange={handleChange}
            className="!h-0 !pointer-events-none !opacity-0"
          />
        </div> */}
        <div className={'flex items-center'}>
          {/* <Button
            type="text"
            icon={<LeftOutlined />}
            className={'!text-sm   font-bold !m-0'}
            onClick={goToPreviousDay}
          /> */}
          <Typography.Text className={'!text-sm  font-bold !m-0'}>
            {moment(selectedDate).format('dddd, MMMM D, YYYY')}
          </Typography.Text>
          {/* <Button
            type="text"
            icon={<RightOutlined />}
            className={'!text-sm  font-bold !m-0'}
            onClick={goToNextDay}
          /> */}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          {/* switch */}
          <div
            className="flex items-center h-8 gap-2 px-4 bg-white rounded-md"
            style={{ border: '1px solid rgb(220, 220, 228)' }}
          >
            <span
              className={
                !isTeam ? 'font-semibold text-[#0653fa]' : 'text-gray-500'
              }
            >
              My
            </span>
            <Switch
              checked={isTeam}
              size="small"
              onChange={(checked) => setIsTeam(checked)}
            />
            <span
              className={
                isTeam ? 'font-semibold text-blue-600' : 'text-gray-500'
              }
            >
              Team
            </span>
          </div>

          {/* all follow ups */}
          <Link to={'/follow-up/all'} className="!font-bold !text-xs ml-1">
            All Follow-ups
          </Link>
        </div>
      </div>
      {/* list */}
      {Object.values(followUpData.data).flat().length ? (
        <div className="flex flex-col gap-6 mb-6">
          {/* overdue list */}
          {followUpData.statistics?.overdue ? (
            <div className="flex flex-col gap-4">
              <h4 className="font-bold  !text-base text-red-500 flex gap-2 items-center">
                <FontAwesomeIcon icon={faCircleInfo} />
                Overdue ({followUpData.statistics?.overdue || 0})
              </h4>
              {followUpData?.data?.overdue?.length
                ? followUpData?.data?.overdue.map((item) => {
                    return (
                      <DetailCard
                        data={item}
                        key={item.id}
                        borderColor={'#ef4444'}
                        onAssign={() =>
                          handleLoadFollowUps(selectedDate, isTeam)
                        }
                      />
                    );
                  })
                : null}
            </div>
          ) : null}
          {/* today list */}
          {followUpData.statistics?.today ? (
            <div className="flex flex-col gap-4">
              <h4 className="font-bold  !text-base text-[#0653fa] flex gap-2 items-center">
                <FontAwesomeIcon icon={faBell} />
                Today ({followUpData.statistics?.today || 0})
              </h4>
              {followUpData?.data?.today?.length
                ? followUpData?.data?.today.map((item) => {
                    return (
                      <DetailCard
                        data={item}
                        key={item.id}
                        borderColor={'#0653fa'}
                        onAssign={() =>
                          handleLoadFollowUps(selectedDate, isTeam)
                        }
                      />
                    );
                  })
                : null}
            </div>
          ) : null}

          {/* upcoming list */}
          {followUpData.statistics?.upcoming ? (
            <div className="flex flex-col gap-4">
              <h4 className="font-bold  !text-base text-[#64748b] flex gap-2 items-center">
                <CalendarOutlined />
                Upcoming ({followUpData.statistics?.upcoming || 0})
              </h4>
              {followUpData?.data?.upcoming?.length
                ? followUpData?.data?.upcoming.map((item) => {
                    return (
                      <DetailCard
                        data={item}
                        key={item.id}
                        borderColor={'#64748b'}
                        onAssign={() =>
                          handleLoadFollowUps(selectedDate, isTeam)
                        }
                      />
                    );
                  })
                : null}
            </div>
          ) : null}
        </div>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No follow-ups for today"
          className="sm:-translate-x-1/2 sm:fixed sm:-translate-y-1/2 top-1/2 left-1/2"
        />
      )}
      {/* new follow up modal */}
      <CreateFollowUpModal
        setIsOpen={setIsNewFollowUpModalOpen}
        isOpen={isNewFollowUpModalOpen}
        onAssign={() => handleLoadFollowUps(selectedDate, isTeam)}
      />
    </div>
  );
}
